import React, { Component } from "react";
import { connect } from "react-redux";
import { actions } from "./redux";
import CSSModules from "react-css-modules";
import ReactHighcharts from "react-highcharts";
import { seriesColor, number, deepClone, shouldUpdate, tooltip, units } from "./../../../../utils";
import styles from "./styles.scss";
import moment from "moment";
import HtmlParser from "react-html-parser";
import ChartWithSyncedZoom from '../ChartWithSyncedZoom/ChartWithSyncedZoom';
import { actions as chartTooltipActions } from "../ChartTooltip/redux";
import ToggleChartSeries from '../../../ToggleChartSeries/ToggleChartSeries';

let count = 0;
const idPrefix = "LineChart";
const dateFormat = "dddd, MMM Do, h:mm A";

const config = {
	chart: {
		animation: false,
		marginBottom: 85,
		zoomType: "x",
		panning: true,
		panKey: "shift",
		style: {
			fontFamily: "Helvetica"
		},
		turboThreshold: 0
	},
	credits: {
		enabled: false
	},
	colors: seriesColor.getSeriesColors(),
	title: {
		text: "Line Chart",
		align: "left",
		margin: 60,
		style: {
			color: "#4D4D4D",
			"font-size": "20px",
			"font-weight": "600"
		}
	},
	legend: {
		itemStyle: {
			color: "#999",
			fontWeight: "normal",
			fontSize: "14px"
		},
		align: "center",
		verticalAlign: "bottom",
		layout: "horizontal"
	},
	tooltip: {
		enabled: false,
		shared: true,
		formatter: function() {
			var s =
				'<span style="font-size:10px">' +
				moment(this.x)
					.utc()
					.format(dateFormat) +
				"</span>";

			this.points.forEach(point => {
				s +=
					'<br /><b><span style="color:' +
					point.point.color +
					'">' +
					point.series.name +
					":</span></b> " +
					(point.point.desc
						? "<br />" + point.point.desc.replace("\n", "<br />").replace("\r", "<br />")
						: number.parseNumber(point.y) + " " + units.getUnitName(point.point.options.units));
			});

			return s;
		}
	},
	xAxis: {
		type: "datetime",
		tickWidth: 0,
		lineColor: "#e6e6e6",
		labels: {
			y: 30,
			style: {
				fontSize: "14px",
				color: "#999"
			}
		}
	},
	plotOptions: {
		line: {
			dataGrouping: {
				enabled: false,
				groupAll: true
			},
			turboThreshold: 0,
			marker: {
				enabled: false
			}
		}
	},
	yAxis: {
		title: "Run Time",
		labels: {
			formatter() {
				return number.parseNumber(this.value, 1).replace(/0*$|\.0*$|\.$/g, "") + " h";
			},
			style: {
				fontSize: "14px",
				color: "#999"
			}
		}
	},
	responsive: {
		rules: [
			{
				condition: {
					maxWidth: 700
				},
				chartOptions: {
					chart: {
						marginBottom: 190
					}
				}
			},
			{
				condition: {
					minWidth: 700,
					maxWidth: 870
				},
				chartOptions: {
					chart: {
						marginBottom: 170
					}
				}
			},
			{
				condition: {
					minWidth: 870,
					maxWidth: 1000
				},
				chartOptions: {
					chart: {
						marginBottom: 150
					}
				}
			},
			{
				condition: {
					minWidth: 1000,
					maxWidth: 1300
				},
				chartOptions: {
					chart: {
						marginBottom: 130
					}
				}
			},
			{
				condition: {
					minWidth: 1300
				},
				chartOptions: {
					chart: {
						marginBottom: 110
					}
				}
			}
		]
	},
	series: []
};
@CSSModules(styles, { allowMultiple: true })
class LineChart extends Component {
	constructor(props) {
		super(props);
		this.id = tooltip.uuidv4();
		this.chart = React.createRef();
		this.config = deepClone(config);
		this.config.title.text = this.props.component.chartTitle || this.config.title.text;
		this.onChartMouseMove = this.onChartMouseMove.bind(this);
	}

	render() {
		return (
			<div id={this.id}>
                <ReactHighcharts config={this.config} ref={this.chart} isPureConfig={true} />
                <ToggleChartSeries chart={this.chart} />
            </div>
		);
	}

	setup() {
		let chart = this.chart.current.getChart();
		if (chart) {
			this.props.loadData(this.props.component, chart, this.props.timePeriod, this.props.onLoadComplete, this.id);
			setTimeout(() => {
			   if(chart) {
				  chart.reflow();
				  chart.redraw();
			   }
			}, 100);
		}

		var x = document.getElementById(this.id).childNodes[0].childNodes[0];
		x.addEventListener("mousemove", this.onChartMouseMove);
	}

	teardown() {}

	componentDidMount() {
		this.setup();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		this.setup();
	}

	onChartMouseMove(e) {
		e = this.chart.current.chart.pointer.normalize(e);

		let x = Math.floor(this.chart.current.chart.xAxis[0].toValue(e.chartX));
		let isIn = this.chart.current.chart.isInsidePlot(e.chartX - this.chart.current.chart.plotLeft, e.chartY - this.chart.current.chart.plotTop);

		this.props.mouseMovedInContainer(e, x, isIn, moment().valueOf(), this.id);
  }

  componentWillUnmount() {
		var x = document.getElementById(this.id).childNodes[0].childNodes[0];
		x.removeEventListener("mousemove", this.onChartMouseMove);
		this.props.mouseRemove(this.id);
  }

	shouldComponentUpdate(nextProps, nextState) {
		return shouldUpdate(this, nextProps, nextState, ["onLoadComplete"]);
	}
}

const bindAction = dispatch => {
	return {
		loadData: (component, chart, timePeriod, onLoadComplete, id) => dispatch(actions.loadData(component, chart, timePeriod, onLoadComplete, id)),
		mouseMovedInContainer: (e, x, isIn, now, id) => dispatch(chartTooltipActions.mouseMovedInContainer(e, x, isIn, now, id)),
		mouseRemove: (id) => dispatch(chartTooltipActions.remove(id))
	};
};

const mapStateToProps = (state, ownProps) => ({});

export default connect(
	mapStateToProps,
	bindAction
)(ChartWithSyncedZoom(LineChart));



// WEBPACK FOOTER //
// ./src/components/ReportComponents/Charts/LineChart/LineChart.js